import { render } from "./leftNavigation.vue?vue&type=template&id=4b7a9ad1"
import script from "./leftNavigation.vue?vue&type=script&lang=js"
export * from "./leftNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__